import englishMessages from 'ra-language-english'

export const i18nEnglish = {
  ...englishMessages,
  resources: {
    organization: {
      list: 'Organizations',
      edit: 'Edit organization',
      create: 'Create organization',
      title: 'Organizations',
      fields: {
        name: 'Name',
        organizationId: 'Auth0 organization id',
        auth0: 'Auth0 organization',
        apps: 'Linked apps',
      },
      apps: {
        zaken: 'Zaken customer',
      },
      inUseBy: 'linked to %{name}',
      sourceUnavailable: 'Source unavailable: %{source}. Saving is disabled.',
      nameMismatch: 'Name "%{appName}" differs from the Auth0 name "%{auth0Name}".',
      locked: 'This organization has certificates; the link can no longer be changed.',
      authImmutable: 'The Auth0 id cannot be changed after saving.',
      confirmTitle: 'Save organization?',
      confirmContent: 'The Auth0 id cannot be changed later.',
      created: 'Organization created',
      switchTo: 'Switch to this organization',
      close: 'Close',
    },
  },
  ui: {
    accountMenu: 'Account',
    limited: 'Latest %{limit} of %{total}',
  },
  validation: {
    hostname: 'Invalid hostname, e.g. my.municipality.nl',
  },
}
